import _objectSpread from'@babel/runtime/helpers/objectSpread2';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React from'react';import styled from'styled-components';import {useTheme,Button}from'@manulife/mux';var CoBrandingDiv = /*#__PURE__*/styled.div.withConfig({
  displayName: "CoBrandingButton__CoBrandingDiv",
  componentId: "adrnnr-0"
})(["color:", ";"], function (props) {
  return props.fontColor;
});
var CoBrandingButton = function CoBrandingButton(btnProps) {
  var _theme$themeCustomiza;
  var theme = useTheme();
  var children = btnProps.children,
    otherProps = _objectWithoutProperties(btnProps, ["children"]);
  var fontColor = theme === null || theme === void 0 ? void 0 : (_theme$themeCustomiza = theme.themeCustomization) === null || _theme$themeCustomiza === void 0 ? void 0 : _theme$themeCustomiza.fontColor;
  if (fontColor) {
    return /*#__PURE__*/React.createElement(Button, otherProps, /*#__PURE__*/React.createElement(CoBrandingDiv, {
      "data-testid": "testid",
      fontColor: fontColor
    }, children));
  }
  return /*#__PURE__*/React.createElement(Button, otherProps, children);
};
process.env.NODE_ENV !== "production" ? CoBrandingButton.propTypes = _objectSpread({}, Button.propTypes) : void 0;
var CoBrandingButton$1 = CoBrandingButton;export{CoBrandingButton$1 as default};